import { faqData, buildFaqPageJsonLd } from "./faq-data";

export interface RouteMeta {
    path: string;
    title: string;
    description: string;
    ogImage?: string;
    ogType?: string;
    jsonLd?: Record<string, unknown> | Record<string, unknown>[];
}

export const DEFAULT_SEO: RouteMeta = {
    path: "*",
    title: "Nuqi Wealth",
    description:
        "Nuqi Wealth India Pvt Ltd is a SEBI-registered investment adviser offering curated equity portfolios, ETFs, and mutual funds screened for ethical, social, and sustainable principles.",
};

export const routeSeoConfig: RouteMeta[] = [
    {
        path: "/",
        title: "Nuqi Wealth | SEBI-Registered Investment Advisory",
        description:
            "Nuqi Wealth is a SEBI-registered investment adviser offering curated ethical stock portfolios, ETFs, mutual funds, and personalized advisory services in India.",
        jsonLd: buildFaqPageJsonLd(faqData),
    },
    {
        path: "/about",
        title: "About Us | Nuqi Wealth",
        description:
            "Meet the Nuqi Wealth team - financial and tech veterans from Citibank, Standard Chartered, Credit Suisse, Microsoft, IBM and EY leading your investment journey.",
    },
    {
        path: "/press",
        title: "Press & News | Nuqi Wealth",
        description:
            "Read press coverage of Nuqi Wealth, including its DFSA licensing, DIFC recognition, the Landmark Group strategic investment, and NUQI Gold's DMCC platform launch.",
    },
    {
        path: "/appdownload",
        title: "Download the App | Nuqi Wealth",
        description:
            "Download the Nuqi Wealth India app, a SEBI-licensed advisory platform building portfolios around Social Equity, Ethics, Governance and Environmental themes.",
    },
    {
        path: "/privacy",
        title: "Privacy Policy | Nuqi Wealth",
        description:
            "Nuqi Wealth's privacy policy, terms of use, disclaimer, cookie policy and grievance redressal details, including SEBI SCORES portal information for investors.",
    },
    {
        path: "/terms",
        title: "Terms of Use | Nuqi Wealth",
        description:
            "Terms of Use for Nuqi's website and app, covering eligibility, the DFSA-regulated Nuqi Digital Wealth advisory service, Client Agreement, and dispute resolution.",
    },
    {
        path: "/disclaimer",
        title: "Disclaimer | Nuqi Wealth",
        description:
            "Investment risk disclosures for Nuqi Wealth India, covering SEBI IA registration, Interactive Brokers execution services, and regulatory contact details.",
    },
    {
        path: "/cookies",
        title: "Cookies Policy | Nuqi Wealth",
        description:
            "How Nuqi Wealth uses cookies and similar tools to collect technical and usage data from its website and app, and how you can manage your cookie preferences.",
    },
    {
        path: "/stock",
        title: "Stock Details | Nuqi Wealth",
        description:
            "View live price, company profile, technical indicators and fundamental data for individual stocks tracked on the Nuqi Wealth platform.",
    },
    {
        path: "/iris",
        title: "IRIS | Nuqi Wealth",
        description:
            "IRIS by Nuqi Wealth lets you browse trending ethically screened stocks across regions and sectors, with live price and change data - sign up to unlock the full list.",
    },
    {
        path: "/ethosphere",
        title: "Ethosphere | Nuqi Wealth",
        description:
            "Ethosphere is Nuqi Wealth's research hub, featuring monthly editions of insights and articles you can browse by year and month in carousel or grid view.",
    },
    {
        path: "/contact",
        title: "Contact Us | Nuqi Wealth",
        description:
            "Get in touch with Nuqi Wealth through our contact form, or visit our FAQ section for answers about your account and investing through the Nuqi mobile app.",
    },
    {
        path: "/ContactsPage",
        title: "Global Offices & Contact | Nuqi Wealth",
        description:
            "Find Nuqi Wealth's global office locations and reach our team through our contact form for expert answers to your investment questions.",
    },
    {
        path: "/partnership",
        title: "Partnerships | Nuqi Wealth",
        description:
            "Nuqi Group partners with the Global Ethical Finance Initiative and IFA Sport to advance ethical finance and financial literacy across Africa, India and the UAE.",
    },
    {
        path: "/MonthlyComplaints",
        title: "Monthly Complaints | Nuqi Wealth",
        description:
            "Monthly disclosure of investor complaints received by Nuqi Wealth, including numbers received, resolved and pending, as required under SEBI regulations.",
    },
    {
        path: "/InvestorCharter",
        title: "Investor Charter | Nuqi Wealth",
        description:
            "Nuqi Wealth's SEBI-mandated Investor Charter, covering investor rights and responsibilities, grievance redressal procedures, and complaint resolution statistics.",
    },
    {
        path: "/Disclosures",
        title: "Disclosures | Nuqi Wealth",
        description:
            "Nuqi Wealth's regulatory disclosures covering annual compliance audits, the use of AI tools in investment advisory services, and our validated UPI payment ID.",
    },
    {
        path: "/prive",
        title: "Nuqi Prive | Bespoke Wealth Management",
        description:
            "Nuqi Prive offers bespoke wealth management, including financial product advising, credit and loan arrangement, custody, deal arrangement, and asset management.",
    },
];

export function getSeoForPath(pathname: string): RouteMeta {
    return routeSeoConfig.find((route) => route.path === pathname) ?? DEFAULT_SEO;
}
